import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import PortfolioShell from './components/PortfolioShell';
import BootSequence from './components/BootSequence';
import ThemeProvider from './components/ThemeProvider';

function App() {
  const [isBooting, setIsBooting] = useState(true);
  const [bootComplete, setBootComplete] = useState(false);

  useEffect(() => {
    // Boot sequence duration
    const bootTimer = setTimeout(() => {
      setBootComplete(true);
      setTimeout(() => {
        setIsBooting(false);
      }, 7000); // Small delay for smooth transition
    }, 5000); // 4 second boot sequence

    return () => clearTimeout(bootTimer);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          {isBooting ? (
            <BootSequence onComplete={() => setBootComplete(true)} />
          ) : (
            <Routes>
              <Route path="/" element={<PortfolioShell />} />
            </Routes>
          )}
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;